// extracted by mini-css-extract-plugin
export default {"title":"mediaChannel_title__WpTJo","mediaChannelWrapper":"mediaChannel_mediaChannelWrapper__Oyfiz"};